// Utilities
// @ts-nocheck
import { defineStore } from 'pinia'
import ObraStore from '@/store/obra'
import UserStore from '@/store/user'
import versoes from "../assets/logVersoesSistema.js";
import config from "../config.js";
import { Auth, Amplify } from 'aws-amplify';
import awsconfig from '@/aws-exports.js';
import { useRouter } from "vue-router";
const router = useRouter();
Amplify.configure(awsconfig);

export async function atualizaSessao(user) {
  
  console.trace()
  localStorage.removeItem('user')
  try {
    if (user.tipo === 'cliente') { // FIXME: cliente não está caindo nesse logout????
      
      await Auth.signOut()
      // FIXME: O Redirect para login não está funcionando
      // router.push('/login')
      return
    } else {
      
      console.trace()
      const d = await Auth.federatedSignIn({ customProvider: config.PROVIDER })

      
    }
  } catch (e) {
    const d = await Auth.federatedSignIn({ customProvider: config.PROVIDER })
  }
    
}

export default defineStore('helpers', {
  state: () => ({
    versao: null,
  }),
  actions: {
    async atualizaUser(user) {
      await atualizaSessao(user);
    },
    async verificaVersaoCache() {
      const userStore = UserStore();
      let versaoAtual = localStorage.getItem('versao')
      
      if (versoes[0].versao !== versaoAtual) {
        console.error('NOVA VERSÃO DO PROGALI')
        window.localStorage.clear() // TODO: AQUI ESTÁ LIMPANDO TODO LOCAL STORAGE, O IDEAL É LIMPAR APENAS AS COLUNAS PQ SE NÃO ELE ENVIA PARA O LOGIN
      } else if (userStore.user?.email && userStore.expiraEm < Date.now()) {
        console.error('USUARIO EXPIRADO')
        await atualizaSessao(JSON.parse(localStorage.getItem('user')))
      }
      
      if (!versaoAtual) {
        console.error("VERSÃO NÃO ENCONTRADA NO CACHE");
        versaoAtual = versoes[0].versao;
        localStorage.setItem("versao", versaoAtual);
      }
    },
  },
})
